<template>
    <div class="HCxF">
        <atomic-search-interface class="container container-fluid research-hub" fields-to-include='["bodyz32xtez120xt","summary","newsz32xpublishz32xdate","isez120xternallink"]' :search-hub="searchHub">
            <div class="heading-container">
                <div v-html="listingHeader"></div>
                <hcxf-news-status></hcxf-news-status>
            </div>
           <div class="row mb-4">
            <div class="col-lg-9">
                    <atomic-layout-section section="main">
                        <hcxf-news-results />
                        <coveoPagination></coveoPagination>
                    </atomic-layout-section>
                </div>

                <div class="col-lg-3">
                </div>
           </div>
        </atomic-search-interface>
    </div>
</template>

<script>
    import coveoPagination from './atomic-pagination.vue'

    export default {
         data() {
            return { 
                allLinks:[]
            };
        },
        props: {
            accessToken: {
                type: String,
                required: true,
            },
            organizationId: {
                type: String,
                required: true,
            },
            searchHub: {
                type: String,
                required: true,
            },
            listingHeader: {
                type: String,
                required: true
            },
            indexName: {
                type: String,
                required: true,
            },
            templateId: {
                type: String,
                required: true,
            },
        },
        methods: {
            async initInterface() {

                await customElements.whenDefined("atomic-search-interface");
                const searchInterface = document.querySelector("atomic-search-interface");

                await searchInterface.initialize({
                    accessToken: this.accessToken,
                    organizationId: this.organizationId,
                    preprocessRequest: (request, clientOrigin, metadata) => {
                        const body = JSON.parse(request.body);
                        if (clientOrigin === 'searchApiFetch') {
                            body.aq ='(@source==(\"' + this.indexName + '\") ( @z95xtemplate=' + this.templateId + '))';
                            body.searchHub = this.searchHub;
                        }
                        request.body = JSON.stringify(body);
                        return request;
                    },
                });
                
                var engine = searchInterface.engine;
                searchInterface.executeFirstSearch();                
                
                engine.subscribe(() => {
                    setTimeout(()=>{
                        this.checkForCardLink();
                        this.updateSpeedBump();
                           
                    },500);                                      
                });
            },
            
        checkForCardLink() {                
            const nodes = document.querySelector('atomic-result-list').shadowRoot;
            const shadowNode = nodes.querySelectorAll("[part='outline']");
            if (shadowNode.length > 0) {
                    shadowNode.forEach(node => {
                    const resultRoot = node.shadowRoot;
                    if(resultRoot) {
                        const link = resultRoot.querySelector('.result-link a')
                       const isExternalElement = resultRoot.querySelector('.isExternal');

                        const isInternalLink = isExternalElement === null 
                            ? false : isExternalElement.innerText == 0 
                            ? false : isExternalElement.innerText == 1 
                            ? true : false;

                        if(link && link.getAttribute('href')){
                            if (isInternalLink && !link.classList.contains('twoClick')) {
                                link.classList.add('twoClick') 
                                this.allLinks.push(link);
                            } 
                    }
                    }
                })
            }
        },
        updateSpeedBump() {
            const speedBumps = this.allLinks;
            const speedBumpLink = document.querySelector('#speed-bump-link');
            window.activeSpeedBumpLink = null;
            Array.from(speedBumps).forEach((element, index) => {
            if(!element.hasAttribute('speed-bump-set')) {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.activeSpeedBumpLink = event.currentTarget;
                    speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));
                    speedBumpLink.click();
                    });

                element.setAttribute('speed-bump-set', '');
                }
            });
            },
       
        }, 
        mounted() {
            this.initInterface();
        },
        components: {
            coveoPagination: coveoPagination
        }
    }
</script>

<style lang="scss">
    .HCxF .c-listing-header {
        margin: 0;
        padding: 0;
    }

    .HCxF .c-listing-header__heading {
        margin-bottom: 0;
    }

    .heading-container .container-fluid {
        padding-inline: 0;
    }

    .HCxF .heading-container {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding-bottom: 4px;

        @media (min-width : 768px) {
            padding-top: 30px;
            flex-direction: row;
            align-items: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-news.vue